import type { IDisposable } from './IDisposable';

export class AutoDisposer<T extends () => void> implements IDisposable {
  private _disposer?: T;

  public constructor(disposer: T) {
    if (disposer === undefined) {
      throw new Error('Disposer is invalid');
    }
    this._disposer = disposer;
  }

  public dispose(): void {
    if (!this._disposer) {
      throw new Error('Already disposed');
    }
    this._disposer();
    this._disposer = undefined;
  }
}
